import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

export default function Support() {
  const { user, loading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (loading) return;
    if (!user) {
      navigate("/login?next=/support", { replace: true });
      return;
    }
    const timer = window.setTimeout(() => {
      window.dispatchEvent(new CustomEvent("open-support"));
    }, 0);
    return () => window.clearTimeout(timer);
  }, [user, loading, navigate]);

  return null;
}
